import {
  DealerListSuccess,
  ALlAssignDealerListSuccess,
} from '../../actionTypes/dealerActions';

const inititalState = {
  dealerList: [],
  allAssignDealerList: [],
};

export const dealerReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case DealerListSuccess:
      return {
        ...state,
        dealerList: payload,
      };
    case ALlAssignDealerListSuccess:
      return {
        ...state,
        allAssignDealerList: payload,
      };
    default:
      return state;
  }
};
